import React, { useCallback, useContext, useMemo } from 'react';
import { Modal } from 'react-responsive-modal';
import { Icon } from '@iconify/react';
import { TDialogProps } from './d';
import ModalContext from './context';
import { useStoreState } from '@store';
import Translation from '@common/translation';

const Dialog = ({
                  Context,
                  text,
                }: TDialogProps) => {

  const { showLoading } = useStoreState((state) => state);
  const {
    isOpen,
    onReject,
    onAccept,
    refProps,
    modalTitle,
    refSubmit,
    isActionsButtonsVisible,
    isCloseAction,
    noPadding,
    buttonSubmitLabel,
    buttonCancelLabel,
    center,
    closeOnOverlayClick = false,
    closeOnEsc = true,
    showCloseIcon = true,
    isDarken = false,
    overlayClassName,
  } = useContext(ModalContext);

  const handlerClose = useCallback(() => {
    onReject && onReject(false);
  }, [onReject]);

  const onCloseDialog = useCallback((event: any, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason !== 'backdropClick') handlerClose();
  }, [handlerClose]);

  const onSubmitActions = useCallback(async () => {
    // setLoading();
    try {
      const exeVal = (refSubmit.current as any)?.submit && await (refSubmit.current as any).submit();
      if (exeVal) {
        onReject();
        onAccept();
      }
    } finally {
      //resetLoading();
    }

  }, [onAccept, onReject, refSubmit]);

  const _title = refProps.current?.title;
  const title = _title || modalTitle;

  const customStyles = useMemo(() => ({
    modal: {
      animation: `${isOpen ? 'customEnterAnimation' : 'customLeaveAnimation'} 500ms`,
      background: 'rgb(240, 240, 240)',
      borderRadius: '15px',
      padding: !noPadding ? '9px' : '0',
    },
    overlay: {
      background: isDarken ? 'rgba(0, 0, 0, 0.8)' : 'rgba(0, 0, 0, 0.5)',
      padding: '2px'
    },
  }), [noPadding, isDarken, isOpen]);

  const handleLoading = useCallback(() => {
    if (showLoading) return;
    handlerClose();
  }, [handlerClose, showLoading]);

  if(!isOpen) return null;

  return (
    <Modal
      open={isOpen}
      onClose={handleLoading}
      styles={customStyles}
      center={center}
      closeOnOverlayClick={closeOnOverlayClick}
      closeOnEsc={closeOnEsc}
      showCloseIcon={showCloseIcon && !showLoading}
      classNames={{
        overlay: overlayClassName,
      }}
    >
      <div className={'base-modal-container'}>
        {title || isCloseAction ? <div className={'base-modal-header'}>
          <Translation use={title || ''} as={'div'} />
          {isCloseAction && <Icon icon={'mdi:close'} onClick={handlerClose} />}
        </div> : null}
        <div className={'base-modal-content'}>
          {
            Context ? (
                <Context
                  {...(refProps.current || {})}
                />
              ) :
              text ? text : null
          }
        </div>
        {isActionsButtonsVisible && (<div className={'base-modal-footer mx-auto sm:flex mt-6 sm:mt-12'}>
            <button
              className={`base-buttons mr-2 w-full focus:outline-none sm:w-auto font-semibold mt-2 md:mt-0 transition duration-150 ease-in-out bg-mainRed outline-none hover:opacity-75 text-white h-10 px-3 xl:px-5 rounded-md`}
              onClick={onReject}
              type="button"
            >
              <Translation use={buttonCancelLabel || 'Cancel'} />
            </button>
            <button
              className={`base-buttons w-full sm:w-auto font-semibold mt-2 md:mt-0 transition duration-150 ease-in-out bg-mainYellow outline-none hover:opacity-75 text-bgHeader h-10 px-3 xl:px-5 rounded-md`}
              onClick={onSubmitActions}
            >
              <Translation use={buttonSubmitLabel || 'Save'} />
            </button>
        </div>)}
      </div>
    </Modal>
  );
};

export default Dialog;
